import { Component, OnInit, Input } from '@angular/core';
import { Globals } from '../../../globals';
import { DrawSharpnessDefaults } from '../../../models/configuration/draw/annotation-defaults.model';
import { DrawParameterObj } from '../../../models/configuration/draw/annotation-defaults.model';
import { cfgDrawParameter } from '../../../models/configuration/draw/annotation-defaults.model';
import { DrawDefaultsService } from '../draw-defaults/draw-defaults.service';
import {ConfigurationService} from '../configuration.service';
import { MatSnackBar } from '@angular/material/snack-bar';

const ParamName = "DEFAULT_ADJUSTMENTTOOLS";

@Component({
  selector: 'app-draw-adjustment-tools',
  templateUrl: './draw-adjustment-tools.component.html',
  styleUrls: ['./draw-adjustment-tools.component.css']
})
export class DrawAdjustmentToolsComponent implements OnInit {
  sharpness: number;
  adjustmentFactor: number;
  radius: number;
  threshold: number;

  public sharpnessDefaults: DrawSharpnessDefaults;
  public drawParameter: cfgDrawParameter

  constructor(private drawDefaultService: DrawDefaultsService, public configurationService: ConfigurationService,  private snackBar: MatSnackBar) { }
  getDrawParameters(parameterName: string) {
    let promise = new Promise((resolve, reject) => {
      this.drawDefaultService.getDrawDefaults(parameterName)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  ngOnInit(): void {
    this.getDrawParameters(ParamName)
      .then((result: cfgDrawParameter) => {
        this.drawParameter = result;
        if (!this.drawParameter) {
          this.setDefaultValues();
          this.sharpnessDefaults = new DrawSharpnessDefaults();
          this.saveDefaultValues();
          return;
        }
        this.sharpnessDefaults = JSON.parse(this.drawParameter.ParameterValue);
        this.sharpness = this.sharpnessDefaults.sharpness;
        this.adjustmentFactor = this.sharpnessDefaults.adjustmentFactor;
        this.radius = this.sharpnessDefaults.radius;
        this.threshold = this.sharpnessDefaults.threshold;
      }, err => {
        this.setDefaultValues();
        this.sharpnessDefaults = new DrawSharpnessDefaults();
        this.saveDefaultValues();
      });

  }

  setDefaultValues() {
    this.sharpness = 50;
    this.adjustmentFactor = 50;
    this.radius = 15;
    this.threshold = 0;

  }
  saveDefaultValues() {
    this.sharpnessDefaults.sharpness = this.sharpness;
    this.sharpnessDefaults.adjustmentFactor = this.adjustmentFactor;
    this.sharpnessDefaults.radius = this.radius;
    this.sharpnessDefaults.threshold = this.threshold;

  }

  async onSave(e) {
    this.saveDefaultValues();
    const drawParam = new DrawParameterObj();
    drawParam.parameterName = ParamName
    const annDefaults = JSON.stringify(this.sharpnessDefaults);
    drawParam.parameterValue = annDefaults;
    await this.drawDefaultService.saveDrawDefaults('00000000-0000-0000-0000-000000000000', drawParam).toPromise();
    this.createMessage('Configuration Saved', 'Success');
    this.configurationService.setClean();
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }


}
